import { render, staticRenderFns } from "./ProcesoImpresion.vue?vue&type=template&id=05fb4ca2&"
import script from "./ProcesoImpresion.vue?vue&type=script&lang=js&"
export * from "./ProcesoImpresion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports